import React, { useState, useEffect } from 'react';

/**
 * @description Formulario para crear o editar un equipo.
 * @param {object} props
 * @param {object} [props.equipment] Equipo a editar. Si es null, crea uno nuevo.
 * @param {Array}  props.projects    Lista de proyectos para el selector.
 * @param {Function} props.onSave   Callback con los datos del formulario.
 * @param {Function} props.onCancel Callback al cancelar.
 */
const EquipmentForm = ({ equipment, projects, onSave, onCancel }) => {
  const [name, setName] = useState('');
  const [brand, setBrand] = useState('');
  const [installation_year, setInstallationYear] = useState('');
  const [comments, setComments] = useState('');
  const [project_id, setProjectId] = useState('');

  useEffect(() => {
    if (equipment) {
      setName(equipment.name || '');
      setBrand(equipment.brand || '');
      setInstallationYear(equipment.installation_year || '');
      setComments(equipment.comments || '');
      setProjectId(equipment.project_id || '');
    } else {
      setName('');
      setBrand('');
      setInstallationYear('');
      setComments('');
      setProjectId('');
    }
  }, [equipment]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({
      name,
      brand,
      installation_year: Number(installation_year),
      comments: comments || undefined,
      project_id: Number(project_id),
    });
  };

  return (
    <form onSubmit={handleSubmit} style={styles.form}>
      <div className="modal-field-group">
        <label className="modal-field-label" htmlFor="eq-name">Nombre del equipo</label>
        <input
          id="eq-name"
          className="modal-field"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Ej: Ascensor Principal"
          required
        />
      </div>
      <div className="modal-field-group">
        <label className="modal-field-label" htmlFor="eq-brand">Marca</label>
        <input
          id="eq-brand"
          className="modal-field"
          value={brand}
          onChange={(e) => setBrand(e.target.value)}
          placeholder="Ej: Otis"
          required
        />
      </div>
      <div className="modal-field-group">
        <label className="modal-field-label" htmlFor="eq-year">Año de instalación</label>
        <input
          id="eq-year"
          type="number"
          className="modal-field"
          value={installation_year}
          onChange={(e) => setInstallationYear(e.target.value)}
          placeholder="Ej: 2015"
          min="1900"
          max="2100"
          required
        />
      </div>
      <div className="modal-field-group">
        <label className="modal-field-label" htmlFor="eq-project">Proyecto</label>
        <select
          id="eq-project"
          className="modal-field"
          value={project_id}
          onChange={(e) => setProjectId(e.target.value)}
          required
        >
          <option value="">Seleccione un proyecto</option>
          {projects.map((p) => (
            <option key={p.project_id} value={p.project_id}>
              {p.name}
            </option>
          ))}
        </select>
      </div>
      <div className="modal-field-group">
        <label className="modal-field-label" htmlFor="eq-comments">Comentarios (opcional)</label>
        <textarea
          id="eq-comments"
          className="modal-field modal-field-textarea"
          value={comments}
          onChange={(e) => setComments(e.target.value)}
          placeholder="Comentarios adicionales..."
          rows={3}
        />
      </div>

      <div className="modal-footer">
        <button type="button" onClick={onCancel} className="modal-btn-secondary">
          Cancelar
        </button>
        <button type="submit" className="modal-btn-primary">Guardar</button>
      </div>
    </form>
  );
};

// El gap entre campos vive acá porque Modal.js solo controla el espaciado
// de su único hijo directo (el <form>).
const styles = {
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '18px',
  },
};

export default EquipmentForm;
